import { Pipe, PipeTransform } from '@angular/core';
import { KPIRouteStateColor } from './kpi-route-state-color';

@Pipe({
    name: 'kpiRouteState',
    standalone: false
})
export class KpiRouteStatePipe implements PipeTransform {
  transform(value: string): any {
    // Logic to determine styles based on the input value
    return {
      'color': KPIRouteStateColor.getRouteStatusColor(value),
    };
  }
}
